
import CPModal from '../components/globals/CPModal.vue';
import CPLogin from '../components/login/CPLogin.vue';
import CPLoginPrivacyFooter from '@/components/globals/CPLoginPrivacyFooter.vue';

import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    CPModal,
    CPLogin,
    CPLoginPrivacyFooter,
  },
})
export default class Login extends Vue {
  public username: string | null = null;
  public password: string | null = null;
}
